import React, { Fragment, useContext, useEffect, useState } from "react";
import { DashboardPilote } from "./DashboardPilote";
import { USER_ROLE } from "../components/utils/contantHelpers";
import { ProgrammeContext } from "../../contexts/UserContext";
import { DashboardStartup } from "./DashboardStartup";
import { DashboardConsultant } from "./DashboardConsultant";


export function Dashboard () {

  const [projet] = useContext(ProgrammeContext);
  const [role, setRole] = useState('');

  useEffect(() => {
    if(projet?.role) {
      setRole(projet.role.libelle)
    }
  }, [projet?.role])
  
  const renderDashboard = () => {
    switch (role) {
      case USER_ROLE.BAILLEUR:
      case USER_ROLE.PILOTE:
        return <DashboardPilote />;
      case USER_ROLE.STARTUP:
        return <DashboardStartup />;
      case USER_ROLE.CONSULTANT:
        return <DashboardConsultant />;
      default:
        return null;
    }
  };

  return <Fragment>{renderDashboard()}</Fragment>;
}


// export default Dashboard;